const box = document.getElementsByClassName('grid__video-block')
const boxNodes = Array.from(box)
const video = document.getElementsByClassName('grid__video')
const videoNodes = Array.from(video)
const imageNodes = Array.from(document.getElementsByClassName('fallback'))

if (boxNodes.length > 0 && window.innerWidth > 860) {
    let stopped = false

    videoNodes.map((node, index) =>
        node.addEventListener('timeupdate', function () {
            if (this.currentTime >= 0.2 && !stopped) {
                this.pause()
                stopped = true
            }
        }))

    const playHover = () =>
        boxNodes.forEach((node, index) => {
            node.addEventListener('mouseenter', () =>
                videoNodes[index].play())

            node.addEventListener('mouseleave', () =>
                videoNodes[index].pause())
        })

    window.onload = playHover
}
else if (window.innerWidth <= 860)
    videoNodes.forEach((node, index) => {
        imageNodes[index].style.display = 'block'
        node.style.display = 'none'
    })
